import { Routes } from '@angular/router';

import { MainMenuComponentResolver } from './auth/resolvers/mainMenu.reolver';
import { AuthGuard } from './guards/auth.guard';

/**
 * Application routes for standalone architecture
 *
 * Key changes from module-based routing:
 * - loadChildren now loads route arrays, not modules
 * - loadComponent for direct component lazy loading
 * - All components are already standalone
 */
export const routes: Routes = [
    {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full',
    },
    {
        path: 'confirmation-code/:code',
        redirectTo: 'auth/confirmation-code/:code',
        pathMatch: 'full',
    },
    {
        path: 'login/:email/:code',
        redirectTo: 'auth/login/:email/:code',
        pathMatch: 'full',
    },

    // Auth routes - lazy load auth route configuration
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then((m) => m.AuthRoutes),
    },

    // Dashboard routes - lazy load dashboard route configuration
    // This is where ReceiptService will be provided at route level!
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.DashboardRoutes),
        canActivate: [AuthGuard],
    },

    // Main menu - already standalone component
    {
        path: 'main',
        loadComponent: () => import('./main-menu/main-menu.component').then((m) => m.MainMenuComponent),
        resolve: { MainMenuComponentResolver },
        canActivate: [AuthGuard],
    },

    // Challenge change password - already standalone component
    {
        path: 'challenge-change-password',
        loadComponent: () =>
            import('./dashboard/components/challenge-change-password/challenge-change-password.component').then(
                (m) => m.ChallengeChangePasswordComponent
            ),
    },
];
